<template lang="pug">
  div
    aside.shadow-lg.transform.top-12.left-0.bg-white.fixed.h-full.ease-in-out.transition-all.duration-300.z-30(
      :class="[`w-${width}`, open ? 'translate-x-0' : '-translate-x-full']"
    )
      button.absolute.top-0.right-0(@click="open = false")
        sw-icon.mt-16.mr-2(name="close")
      div.mt-20
        slot
    .z-30.fixed.-left-16.cursor-pointer.shadow-lg.p-2.transform.-rotate-90.rounded.flex(
      v-if="!open"
      class="top-1/2"
      :data-purpose="dataPurposeProp"
      @click="open = true"
    )
      slot(name='expandButtonText')
      sw-icon.ml-2(name="arrow-down")
</template>

<script>
export default {
  name: 'SwDrawer',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: 'auto',
    },
    dataPurposeProp: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      open: false,
    };
  },
  created () {
    if (this.show) this.open = true;
  },
};
</script>
